import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { CoreLogService } from '../../../core/services/log.service';

@Component({
  selector: 'sot-countdown',
  templateUrl: "./countdown.component.html",
  styleUrls: ["./countdown.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CountDown implements OnInit, OnDestroy {
  /** start of the coundowns, for count down from, default 10 */
  @Input() countdown_sec: number = 10;
  /** shows controls, default true */
  @Input() controls: boolean = true;
  /** teilt die status änderung mit. start, wenn der timer gestartet wird, stop beim anhalten, done zum schluss wenn der count 0 erreicht hat */
  @Output() statusChanged = new EventEmitter<"start" | "stop" | "done">();

  /** animation class */
  public statusClass: string = "paused";
  /** current count */
  public count: number;

  constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService) {
    console.debug("--- sot-countdown constructor")
  }

  ngOnInit() {
    console.debug("--- sot-countdown ngOnInit")
    const me = this;
    // setzt den initial counter für die anzeige
    me.count = me.countdown_sec;
    me.start();
  }

  ngOnDestroy() {
    console.debug("--- sot-countdown ngOnDestroy")
    if (this.countDownInterval) {
      clearInterval(this.countDownInterval);
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("CountDown.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public get circle_animation_duration(): string {
    return this.countdown_sec + 's';
  }

  /** referenz auf den js interval */
  private countDownInterval: NodeJS.Timer;

  /** startet den countdown */
  private start(): void {
    const me = this;
    if (!me.countDownInterval) {
      me.statusClass = "running";
      me.countDownInterval = setInterval(() => {
        if (me.count > 0) {
          me.count -= 1;
          if (me.count > 0){
            me.PushChanges();
          } else {
            me.stop();
            me.statusChanged.next("done");
          }
        }
      }, 1000); // 1000 every second
      me.statusChanged.next("start");
    }
  }

  /** hält den countdown an */
  private stop(): void {
    const me = this;
    if (me.countDownInterval) {
      clearInterval(me.countDownInterval);
      me.countDownInterval = null;
      me.statusClass = "paused";
      me.statusChanged.next("stop");
      me.PushChanges();
    }
  }

  public pause(): void {
    if (this.count > 0) {
      this.stop();
    }
  }

  public play(): void {
    if (this.count > 0) {
      this.start();
    }
  }
}